import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=79622a48&scoped=true"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"
import style0 from "./editTag.vue?vue&type=style&index=0&id=79622a48&prod&lang=scss&scoped=true"
import style1 from "./editTag.vue?vue&type=style&index=1&id=79622a48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79622a48",
  null
  
)

export default component.exports